module.exports = __webpack_public_path__ + "img/logo-404.4cf192cb.png";